import 'fomantic-ui-dropdown/dropdown'
import 'semantic-ui-transition/transition'
import 'semantic-ui-api/api'

import { Controller } from '@hotwired/stimulus'

$.fn.dropdown.settings.message.addResult = 'Ajouter <b>{term}</b>'
$.fn.dropdown.settings.message.count = '{count} sélectionnés'
$.fn.dropdown.settings.message.maxSelections = '{maxCount} sélections maximum'
$.fn.dropdown.settings.message.noResults = 'Aucun résultat trouvé'

export default class extends Controller {
  static values = {
    config: { type: Object, default: {} }
  }

  connect() {
    this.$element = $(this.element)

    if (!this.element.classList.contains('selection')) {
      this.element.classList.add('dropdown--from-button')
    }

    this.$element.dropdown({
      ...this.config(),
      onShow: () => setTimeout(() => this.adjustDirection(), 0)
    })

    if (this.$element.hasClass('allow-additions')) {
      this.$element.children('.search').keydown(event => {
        if (event.keyCode === 13) event.preventDefault()
      })
    }
  }

  adjustDirection() {
    if ('dropdownNoUpward' in this.$element[0].dataset) return
    const rect = this.element.getBoundingClientRect()
    const menu = this.$element.find('.menu')

    if (menu.length === 0) return

    const menuHeight = menu.outerHeight()
    const spaceBelow = window.innerHeight - rect.bottom
    const spaceAbove = rect.top

    const isInModal = this.element.closest('[data-controller~="ui--modal-component"]')

    if ((spaceBelow < menuHeight && spaceAbove > menuHeight) || isInModal) {
      this.$element.addClass('upward')
    } else {
      this.$element.removeClass('upward')
    }
  }

  config() {
    const isApi = !!this.configValue.apiSettings

    const baseConfig = {
      direction: 'auto',
      forceSelection: false,
      ignoreDiacritics: true,
      ignoreSearchCase: true,
      preserveHTML: false,
      match: 'text',
      className: {
        dropdown: 'dropdown',
        label: 'label label-default'
      },
      selector: {
        dropdown: '.dropdown'
      },
      onChange(value, text, $choice) {
        if ($(this).hasClass('search')) document.activeElement.blur()
        this.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }

    if (!isApi) {
      baseConfig.fullTextSearch = 'exact'
    }

    const o = {
      ...baseConfig,
      ...(this.$element.hasClass('dropdown-with-blank') ? { placeholder: false } : {}),
      ...(this.$element.hasClass('allow-additions') ? { allowAdditions: true, hideAdditions: false } : {}),
      ...this.configValue
    }

    if (isApi && o.apiSettings) {
      o.apiSettings = {
        ...o.apiSettings,
        throttleFirstRequest: false,
        cache: false,
        responseAsync: (settings, resolve) => {
          $.ajax({
            url: settings.url,
            dataType: 'json',
            success: response => resolve(response),
            error: () => resolve({ success: false })
          })
        }
      }
    }

    return o
  }
}
